import { createI18n } from "vue-i18n";
import { messages } from "./messages";

const getStoredLocale = () => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem("app_language_code");
  } catch (error) {
    console.error("Failed to read stored locale", error);
    return null;
  }
};

const defaultLocale = getStoredLocale() || "ms-my";

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: defaultLocale,
  fallbackLocale: "en-gbr",
  messages,
});

export default i18n;
